import { takeEvery, put } from "redux-saga/effects";
import {
  getUsersList, getUsersListSuccess, requestRegistrationResponse, getRegistrationData,
  requestRegistrationKey, requestRegistrationKeyResponse, changePinRequest,
  changePinRequestResponse, registerFCMToken,
} from "../../../slices/RegisterSlice";
import api from "../../../../utils/apiService";
import { ENDPOINT } from "../../../../config/endpoints";
import { getLocalStorage } from "../../../../utils/localStorage";
import { LOCALSTORAGE_KEYS } from "../../../../utils/constants";
import { getLoginMetaInfo } from "../../../../helpers/commonHelpers";
import { LOGIN_TYPES } from "../../../../data/constants";

export * from "./shared";

/**
 * WEB variant of `redux-store/saga/login/register`. See `./shared.ts` — the two are close, but
 * not yet identical.
 *
 * ⚠️ `getLoginMetaInfo` is deep-imported to this platform's variant on purpose: the two payloads
 * share only `loginType`, so binding the wrong one would send the other platform's fields.
 */

function* getUsersInfo (action: any): any {
  console.log("getUsersInfo!!");
  const payload = action.payload
  const metaInfo = getLoginMetaInfo({ loginType: LOGIN_TYPES.drkLogin });
  const dataToSend = {
    ...payload,
    metaInfo
  }
  try {
    const response = yield api.request({
      method: 'POST',
      url: ENDPOINT.REGISTER.getDeviceRegister(),
      data : dataToSend
      
    } as any);
    console.log("response getUsersInfo: ", response);
    yield put(getUsersListSuccess(response));

  } catch (error){
    console.log('error',error);
  }
}

  function* fetchRegistrationData(action: any): any {
    console.log("getDeviceRegistrationInfo!!");
    const payload = action.payload
    const metaInfo = getLoginMetaInfo({ loginType: LOGIN_TYPES.drkLogin });
    const dataToSend = {
      ...payload,
      metaInfo
    }
    try {
      const response = yield api.request({
        method: 'POST',
        url: ENDPOINT.REGISTER.getDeviceRegister(),
        data : dataToSend
        
      } as any);
      console.log("response getRegistrationInfo: ", response);
      if(response?.deviceIdentifier){
        localStorage.setItem('deviceIdentifier',response?.deviceIdentifier)
      }
      yield put(getRegistrationData(response));
    } catch (error){
      console.log('error',error);
    }
  }

  function* sendRegistrationKey(action: any): any {
    console.log("sendDeviceRegistrationKey!!");
    let payload = action.payload
    try {
      const response = yield api.request({
        method: 'POST',
        url: ENDPOINT.REGISTER.requestRegistrationKey(),
        data : payload,
        customUrl: true,
      } as any);
      console.log("response sendRegistrationKey: ", response);
     
      yield put(requestRegistrationKeyResponse(response));
  
    } catch (error){
      console.log('error',error);
    }
  }

  function* changePinRequestApi(action: any): any {
    // console.log("getDeviceRegistrationInfo!!");
    let payload = action.payload
    // console.log('Telephone',phoneNumber)
    try {
      const response = yield api.request({
        method: 'POST',
        url: ENDPOINT.REGISTER.getChangePin(),
        data : payload?.dataToSend
      } as any);
      console.log("response changePinRequestApi: ", response);
      payload?.callback && payload.callback(!response?.code);
      yield put(changePinRequestResponse(response));
    } catch (error){
      payload?.callback && payload.callback(false);
      console.log('error',error);
    }
  }

  function* registerFCMTokenApi(action: any): any {
    console.log("registerFCMTokenApi!!");
    let fcmToken = action.payload;
    try {
      const response = yield api.request({
        method: 'POST',
        headers: { deviceIdentifier: getLocalStorage("deviceIdentifier") || "" },
        url: ENDPOINT.REGISTER.registerFCM(fcmToken),
        customUrl: true,
        hideLoader: true,
      } as any);
      console.log("response registerFCMTokenApi: ", response);
      localStorage.setItem(LOCALSTORAGE_KEYS.fcmToken, fcmToken);
    } catch (error){
      console.log('error', error);
    }
  }
  

export default function* root(): any {
  yield takeEvery(getUsersList.type,getUsersInfo);
  yield takeEvery(requestRegistrationResponse.type,fetchRegistrationData);
  yield takeEvery(requestRegistrationKey.type,sendRegistrationKey);
  yield takeEvery(changePinRequest.type, changePinRequestApi);
  yield takeEvery(registerFCMToken.type, registerFCMTokenApi);
}
